import { useCategoryPageBrandFirstSearchResults } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useCategoryPageBrandFirstSearchResults";
import { useCategoryPageProductFirstSearchResults } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useCategoryPageProductFirstSearchResults";
import { useIsCategoryPageError } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useIsCategoryPageError";
import { useIsCategoryPageLoading } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useIsCategoryPageLoading";
import { useShowProductFirstResults } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/useShowProductFirstResults/useShowProductFirstResults";
export var useIsCategoryPageLoadedAndHasNoResults = function() {
    var showProductFirstResults = useShowProductFirstResults();
    var isLoading = useIsCategoryPageLoading();
    var isError = useIsCategoryPageError();
    var products = useCategoryPageProductFirstSearchResults();
    var brands = useCategoryPageBrandFirstSearchResults();
    if (isLoading) {
        return false; // should not show empty state when loading
    }
    if (isError) {
        return true; // should show empty state when error
    }
    if (showProductFirstResults) {
        return products.length === 0;
    }
    return brands.length === 0;
};
